module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_7016.211d47f7.png";